import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, RadialLinearScale, Legend } from 'chart.js';
import { Pie, Doughnut, PolarArea } from 'react-chartjs-2';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Icon, { IconType } from '../Icon/Icon';

interface IProps {
  data: IData;
  type: 'pie' | 'doughnut';
  size?: 'small' | 'medium' | 'large';
}

interface IData {
  labels: string[];
  datasets: { data: number[]; backgroundColor?: string[]; hoverBackgroundColor?: string[]; label?: string }[];
}
const MyChart = (props: IProps) => {
  ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale);
  const [data, setData] = React.useState<IData>(props.data);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let d = props.data;
    if (d.datasets && d.datasets.length > 0) {
      d.datasets.forEach((ds) => {
        ds.data?.forEach((v, i) => {
          if (!ds.backgroundColor) {
            ds.backgroundColor = [];
          }
          ds.backgroundColor[i] = randomRgbaColor();
        });
      });
    }
    setData(d);
    setReady(true);
  }, [props.data]);

  const randomRgbaColor = () => {
    const o = Math.round,
      r = Math.random,
      s = 255;
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',0.7)';
  };

  return (
    <>
      <div>
        <Tabs>
          <TabList>
            <Tab>
              <Icon type={IconType.chart} /> Chart
            </Tab>
            <Tab>
              <Icon type={IconType.data} /> Data
            </Tab>
          </TabList>
          <TabPanel>{ready && 
            <div className={`chart-container ${props.size}`}>{props.type === 'pie' ? 
            <Pie data={data} /> 
            : 
            <Doughnut data={data} />
            }</div>}
          </TabPanel>
          <TabPanel>
            <div className={``}>
              {ready && data.datasets.length > 1 ? (
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th></th>
                      {data.labels.map((x, i) => (
                        <th key={i}>{x}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.datasets.map((ds, i) => (
                      <tr key={i}>
                        <th>{ds.label}</th>
                        {ds.data.map((v, j) => (
                          <td key={j} style={{ backgroundColor: ds.backgroundColor?.[j] }}>
                            {v}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="table table-striped table-bordered">
                  <tbody>
                    {data.datasets[0].data.map((ds, i) => (
                      <tr key={i}>
                        <th>{data.labels[i] ?? ''}</th>
                        <td>{ds}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default MyChart;
